export default __webpack_public_path__ + "static/media/get-verified.221f038a.png";